import { hasGraphqlErrorCode } from './hasGraphqlErrorCode'

/**
 * kpi / kpiPivot の設定取得が VISUALIZE ライセンス不足で拒否されたかを判定する。
 * code はサーバー側 (apps/backend/web/src/graphql/errors.ts の newVisualizeLicenseRequiredError) が設定する。
 */
export const isVisualizeLicenseRequiredError = (error: unknown): boolean =>
  hasGraphqlErrorCode(error, ['VISUALIZE_LICENSE_REQUIRED'])
